import React from 'react';
import { LucideIcon } from 'lucide-react';
import { OpsStatLabel } from './OpsMetricLabels';
import { opsStatCard } from './operationsUi';

type OperationsStatCardProps = {
  label: string;
  value: React.ReactNode;
  sub?: string;
  icon?: LucideIcon;
  accent?: string;
  loading?: boolean;
  infoKey?: string;
};

const OperationsStatCard: React.FC<OperationsStatCardProps> = ({
  label,
  value,
  sub,
  icon: Icon,
  accent = 'text-primary-600 dark:text-primary-400',
  loading,
  infoKey,
}) => (
  <div className={opsStatCard}>
    <div className="flex items-start justify-between gap-2">
      <OpsStatLabel label={label} infoKey={infoKey} />
      {Icon && (
        <div className={`rounded-lg bg-gray-50 p-2 dark:bg-gray-900/80 ${accent}`}>
          <Icon className="h-4 w-4" />
        </div>
      )}
    </div>
    {loading ? (
      <div className="mt-2 h-8 w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
    ) : (
      <p className="mt-2 text-2xl font-bold tabular-nums text-gray-900 dark:text-white">{value}</p>
    )}
    {sub && <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{sub}</p>}
  </div>
);

export default OperationsStatCard;
